import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserUtil } from 'src/app/data/utils/user.utils';
import { AuthService } from '../../../../data/services/auth.service';
import { RedirectToAppStoresComponent } from '../../redirect-to-app-stores/redirect-to-app-stores.component';
import { Credentials } from '../../../../data/models/enum/credentials.enum';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  hide = true;
  loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });

  @Input()
  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }
  isValid: boolean = true;
  loading = false;

  private DEFAULT_ERROR_MESSAGE = 'E-mail e/ou senha incorretos.';
  errorMessage: string | undefined;
  invalidMinPasswordErrorMessage?: string

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly userUtil: UserUtil,
    private readonly dialog: MatDialog
  ) { }

  async onSubmit(): Promise<void> {
    this.loading = true;
    try {
      const result = await this.authService.login(
        this.loginForm.value.email,
        this.loginForm.value.password
      );

      if (result.navigateTo === 'select-tenant') {
        await this.router.navigate([result.navigateTo]);
      } else {
        this.routeTo();
      }
    } catch (ex: any) {
      const forbidden = ex?.status === 403
      const invalidMinimumPassword: boolean = ex?.status === 400 && ex?.error?.data?.type === Credentials.INVALID_MINIMUM_CHARACTERS_PASSWORD && ex?.error?.data?.minimum != null

      if (forbidden) {
        this.handleForbiddenException()
      } else if (invalidMinimumPassword) {
        this.handleInvalidMinimumPasswordException(ex?.error?.data?.minimum)
      } else {
        this.handleAuthException()
      }
    } finally {
      this.loading = false;
    }
  }

  private routeTo(): void {
    if (this.userUtil.isResponsablesProfile() || this.userUtil.isChild()) {
      this.authService.logout();
      this.dialog.open(RedirectToAppStoresComponent);
      return;
    }
    let route = 'news-list';
    if (this.userUtil.isFuncionarioProfile()) {
      route = 'users';
    }
    if (this.userUtil.isProfessorProfile()) {
      route = 'chat';
    }
    this.router.navigate([route]);
  }

  private handleForbiddenException() {
    this.errorMessage =
      'Seu acesso foi interrompido. Para entender o que pode ter ocorrido, procure a instituição';
    this.isValid = false;
    this.resetPasswordValidator();
  }

  private handleInvalidMinimumPasswordException(min: number) {
    this.invalidateMinimumPassword(min)
    this.isValid = true;
  }
  private handleAuthException() {
    this.errorMessage = this.DEFAULT_ERROR_MESSAGE;
    this.isValid = false;
    this.resetPasswordValidator();
  }

  private invalidateMinimumPassword(min: number) {
    this.loginForm.controls['password'].setValidators([Validators.required, Validators.minLength(min)]);
    this.loginForm.controls['password'].updateValueAndValidity();
    this.invalidMinPasswordErrorMessage = `Senha deve conter ao menos ${min} caracteres`;
  }

  private resetPasswordValidator() {
    this.loginForm.controls['password'].setValidators([Validators.required]);
    this.invalidMinPasswordErrorMessage = undefined;
  }
}
